import { call, put } from "redux-saga/effects";

import {
  receivedProgramIdeActivitySets,
  getProgramIdeActivitySetsError,
  getUserIdeActivitySetsError,
  receivedUserIdeActivitySets,
} from "../actions/ideActivitySets";
import {
  showErrorMessage,
} from "../actions/notification";

import * as ideActivitySetsApi from '../api/ideActivitySets';

const errorLoadingMsg = "Uh-oh! Something went wrong—try again.";

export function* getProgramIdeActivitySets({ payload }) {
  try {
    const { data } = yield call(ideActivitySetsApi.getProgramIdeActivitySets, payload);

    if (data?.error) {
      yield put(showErrorMessage(errorLoadingMsg));
      yield put(getProgramIdeActivitySetsError());
    } else {
      yield put(receivedProgramIdeActivitySets(data));
    }

  } catch (e) {
    yield put(showErrorMessage(errorLoadingMsg));
    yield put(getProgramIdeActivitySetsError());
    console.log(e);
  }
}

export function* getUserIdeActivitySets({ payload }) {
  try {
    const { data } = yield call(ideActivitySetsApi.getUserIdeActivitySets, payload);

    if (data?.error) {
      yield put(showErrorMessage(errorLoadingMsg));
      yield put(getUserIdeActivitySetsError());
    } else {
      yield put(receivedUserIdeActivitySets(data));
    }

  } catch (e) {
    yield put(showErrorMessage(errorLoadingMsg));
    yield put(getUserIdeActivitySetsError());
    console.log(e);
  }
}
